module.exports = __webpack_public_path__ + "static/media/filters.d4bc599a.svg";